// LicenseManagement.tsx
import React from "react";
import License from "./LicenseManagementComponents/license";

const LicenseManagement = () => {
  return (
    <div className="mx-auto w-full max-w-screen-lg divide-y divide-gray-200 rounded-xl bg-white p-2">
      <License />
    </div>
  );
};

export default LicenseManagement;
